import template from "./two-bar-chart.html";
import {twoBarChartController} from "./two-bar-chart.controller";
import "./two-bar-chart.scss";

export const TwoBarChartComponent = {
    template,
    controller: twoBarChartController,
    controllerAs: "chartDouble",
    bindings: {
        data: "<",
        lines: "@",
        labels: "@",
        header: "<",
        unique: "<"
    }
};
export default TwoBarChartComponent;


// WEBPACK FOOTER //
// ./sources/components/charts/two-bar-chart/two-bar-chart.component.js